import { cn } from '@/utils/cn';
import { formatAppRoleLabel } from '@/utils/roles';
import type { AppRole } from '@/types/domain';
import ownerIcon from '@/assets/role-emblems/owner.png';
import adminIcon from '@/assets/role-emblems/admin.png';
import officerIcon from '@/assets/role-emblems/officer.png';
import massManagerIcon from '@/assets/role-emblems/mass-manager.png';
import memberIcon from '@/assets/role-emblems/member.png';

interface RoleEmblemProps {
  role: AppRole;
  compact?: boolean;
  className?: string;
}

const roleIcons: Record<AppRole, string> = {
  owner: ownerIcon,
  admin: adminIcon,
  officer: officerIcon,
  mass_manager: massManagerIcon,
  member: memberIcon,
};

export function RoleEmblem({ role, compact = false, className }: RoleEmblemProps): JSX.Element {
  return (
    <span
      className={cn('role-emblem', `role-emblem--${role}`, compact && 'role-emblem--compact', className)}
      title={formatAppRoleLabel(role)}
      aria-label={formatAppRoleLabel(role)}
    >
      <span className="role-emblem__glyph" aria-hidden="true">
        <img src={roleIcons[role]} alt="" className="role-emblem__image" />
      </span>
      {!compact ? <span className="role-emblem__label">{formatAppRoleLabel(role)}</span> : null}
    </span>
  );
}
